import axios from "axios";
import cookie from "cookie";

const service = axios.create({
    timeout: 120000,
});
service.interceptors.request.use(
    (config) => {
        const token = cookie.parse(document.cookie)["course_token"];
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        config.withCredentials = false;
        return config;
    },
    (error) => {
        console.error("Request Error:", error); // for debug
        return Promise.reject(error);
    }
);

export default {
    /**
     * Upload image to OSS
     * @param {File} file - The image file to upload
     * @param {Object} config - Additional axios configuration
     * @returns {Promise} Promise that resolves with the upload result
     */
    uploadImage(file, config = {}) {
        const formData = new FormData();
        formData.append("file", file);

        return service({
            url: "/csp/system/oss/upload",
            method: "post",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            ...config,
        });
    },
};
